import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { computed } from 'vue'

export type MenuType = {
  name: string
  links: MenuItem[]
}

export type MenuItem = {
  label: string
  link: string
  name?: string
  id?: string
  target?: string
}

export function useMenus() {
  const publicMenus: MenuType[] = [
    {
      name: 'Services',
      links: [
        {
          label: 'Employee wellbeing',
          link: '/employee-wellbeing',
          name: 'employee-wellbeing',
        },
        {
          label: 'Advice practices',
          link: '/advice-practices',
          name: 'advice-practices',
        },
        {
          label: 'Super funds',
          link: '/super-funds',
          name: 'Super funds',
        },
        {
          label: 'Personal pricing',
          link: '/personal-pricing',
          name: 'personal-pricing',
        },
      ],
    },
    {
      name: 'About',
      links: [
        {
          label: 'Our story',
          link: '/our-team',
          name: 'our-team',
        },
        {
          label: 'How Otivo makes money',
          link: '/how-otivo-makes-money',
          name: 'how-otivo-makes-money',
        },
        {
          label: 'Security',
          link: '/security',
          name: 'security',
        },
        {
          label: 'Media',
          link: '/media',
          name: 'media',
        },
        {
          label: 'Contact us',
          link: '/contact-us',
          name: 'contact-us',
        },
      ],
    },
    {
      name: 'Resources',
      links: [
        {
          label: 'Financial fitness test',
          link: '/financial-fitness',
          name: 'financial-fitness',
        },
        {
          label: 'Retirement planning',
          link: '/retire',
          name: 'landing.retirement',
        },
        {
          label: 'Retirement calculator',
          link: '/retirement-calculator',
          name: 'retirement-calculator',
        },
        {
          label: 'FAQ',
          link: '/faq',
          name: 'faq',
        },
        {
          label: 'Learning Hub',
          link: '/learn',
          name: 'Learning hub',
        },
        {
          label: 'Super report',
          link: '/super-report',
          name: 'super-report',
        },
        {
          label: 'Wellbeing report',
          link: '/download-wellbeing-report',
          name: 'wellbeing-report-form',
        },
      ],
    },
    {
      name: 'Legal stuff',
      links: [
        {
          label: 'Privacy policy',
          link: '/privacy-policy',
          name: 'privacy-policy',
        },
        {
          label: 'Financial services guide',
          link: 'https://store.otivo.com/FSG/FSCGv1.pdf',
          target: '_blank',
        },
        {
          label: 'Terms and conditions',
          link: '/terms-and-conditions',
          name: 'terms-and-conditions',
        },
      ],
    },
  ]

  const adviserMenus: MenuType[] = [
    {
      name: 'About',
      links: [
        {
          label: 'Security',
          link: '/security',
          name: 'security',
        },
      ],
    },
    {
      name: 'Support',
      links: [
        {
          label: 'Contact us',
          link: '/contact-us',
        },
        {
          label: 'FAQ',
          link: '/faq',
          name: 'faq',
        },
      ],
    },
    {
      name: 'Legal stuff',
      links: [
        {
          label: 'Privacy policy',
          link: '/privacy-policy',
          name: 'privacy-policy',
        },
        {
          label: 'Financial services guide',
          link: 'https://store.otivo.com/FSG/FSCGv1.pdf',
          target: '_blank',
        },
        {
          label: 'Terms and conditions',
          link: '/terms-and-conditions',
          name: 'terms-and-conditions',
        },
      ],
    },
  ]

  // override public menus to update privacy-policy link if whitelabel data is available -- HACK
  // -- TODO: remove this when routing is unified and middleware supported
  const whitelabelData = computed(() => useSessionStore().getWhitelabelData)
  const cfsD2dMenus: MenuType[] = [
    {
      name: 'About',
      links: [
        {
          label: 'Security',
          link: '/security',
          name: 'security',
        },
      ],
    },
    {
      name: 'Support',
      links: [
        {
          label: 'Contact us',
          link: '/contact-us',
        },
        {
          label: 'FAQ',
          link: '/cfs/faq',
          name: 'cfs-faq',
        },
      ],
    },
    {
      name: 'Legal stuff',
      links: [
        {
          label: 'Privacy policy',
          link: whitelabelData.value.privacy_url ?? '/content/privacy-policy',
          name: 'privacy-policy',
        },
        {
          label: 'Financial services guide',
          link: whitelabelData.value.fsg_url ?? 'https://store.otivo.com/FSG/FSCGv1.pdf',
          target: '_blank',
        },
        {
          label: 'Terms and conditions',
          link: whitelabelData.value.terms_and_conditions_url ?? '/content/terms-and-conditions',
          name: 'terms-and-conditions',
        },
      ],
    },
  ]

  return {
    adviserMenus,
    cfsD2dMenus,
    publicMenus,
  }
}
